<template>
  <div class="tosssbgl">
    <!-- tosssbgl -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'tosssbgl',
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {
    let timeStamp = new Date().getTime();

    if (process.env.NODE_ENV === 'development') {
      window.open(
        `https://house-test.zjj.sz.gov.cn/zhwyjg/#/dashboard?grantCode=${this.token}&skipSource=5&t=${timeStamp}`
      );
    } else if (process.env.NODE_ENV === 'production') {

      const auth = ['市局', '区局', '街道办事处', '居民委员会'].includes(this.userInfo.DeptType)

      if (auth) {
        window.open(
          `https://house-web.zjj.sz.gov.cn/zhwyjg/#/dashboard?grantCode=${this.token}&skipSource=5&t=${timeStamp}`        
        );
      } else { 
        window.open(
          `https://house.zjj.sz.gov.cn/zhwyjg/#/dashboard?grantCode=${this.token}&skipSource=5&t=${timeStamp}`
        );
        
      }
    }

    this.$router.go(-1);
  },
};
</script>

<style>
</style>
